import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
  withRouter,
} from 'react-router-dom';
import {
  Box,
  Button,
  Grid,
  makeStyles,
  MuiThemeProvider,
  Typography,
  useTheme,
} from '@material-ui/core';
import Header from '../../Components/Header/index';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import Logo from '../../Assets/ken42-logo.jpg';
import SideNavigation from './Components/sideNavigation.jsx';
import LightTheme from '../../Utils/themes/light-theme';
import Home from './Pages/home/index';
import FileUpload from './Pages/fileUpload/index';
import { useTranslation } from 'react-i18next';
import routes from '../../Utils/routes.json';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  mainContainer: {
    backgroundColor: theme.palette.KenColors.background,
    marginTop: 64,
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('smUp')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      zIndex: 1000,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    overflow: 'hidden',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  container: {
    [theme.breakpoints.up('md')]: {
      //width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },

  wrapper: {
    // display: "flex",
  },
  mainWrap: {
    width: '100%',
    marginTop: '-72px',
  },
}));

function ETLDashboard(props) {
  const { history } = props;
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClick = () => {
    history.push('/app/home');
  };

  return (
    <Box className={classes.mainContainer}>
      <MuiThemeProvider theme={LightTheme}>
        <Router>
          <Header
            logo={Logo}
            title={t('headings:workflow_Manager')}
            titleStyle={{ marginLeft: 30 }}
            handleClick={handleClick}
            history={history}
          />
          <Grid className={classes.wrapper}>
            <Grid className={classes.sidenavWrap}>
              <nav className={classes.drawer} aria-label="mailbox folders">
                <Hidden smUp implementation="css">
                  <Drawer
                    className={classes.drawerContainer}
                    //   container={container}
                    variant="temporary"
                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    classes={{
                      paper: classes.drawerPaper,
                    }}
                    ModalProps={{
                      keepMounted: true, // Better open performance on mobile.
                    }}
                  >
                    <div data-testid="test-wrap">
                      <SideNavigation />
                    </div>
                  </Drawer>
                </Hidden>
                <Hidden smDown implementation="css">
                  <Drawer
                    classes={{
                      paper: classes.drawerPaper,
                    }}
                    variant="permanent"
                    open
                  >
                    <SideNavigation />
                  </Drawer>
                </Hidden>
              </nav>
            </Grid>
            <Grid className={classes.mainWrap}>
              <Switch>
                {/* <Route exact path='/app/etl'>
									<Redirect to={`app/etl/fileUpload`}></Redirect>
								</Route>
								<Route exact path={`app/etl/home`} component={Home} />
								<Route
									exact
									path={`app/etl/fileUpload`}
									component={FileUpload}
								/> */}

                <Route
                  exact
                  path={`${routes.main}/etl/home`}
                  component={Home}
                />
                <Route
                  exact
                  path={`${routes.main}/etl/fileUpload`}
                  component={FileUpload}
                />
              </Switch>
            </Grid>
          </Grid>
        </Router>
      </MuiThemeProvider>
    </Box>
  );
}

export default ETLDashboard;
